import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_RECONCILIATION_AGENCY_BILL, APP_FILE_RECONCILIATION_CUSTOMER_PAYABLE, APP_FILE_RECONCILIATION_DIRECT_BILL } from "./Reconciliation.constants";

const ReconciliationAgencyBill = Loadable(
  lazy(() =>
    import("./ReconciliationAgencyBill").then(
      ({ ReconciliationAgencyBill }) => ({
        default: ReconciliationAgencyBill,
      })
    )
  )
);

const ReconciliationDirectBill = Loadable(
  lazy(() =>
    import("./ReconciliationDirectBill").then(
      ({ ReconciliationDirectBill }) => ({
        default: ReconciliationDirectBill,
      })
    )
  )
);

const ReconciliationCustomerPayable = Loadable(
  lazy(() =>
    import("./ReconciliationCustomerPayable").then(
      ({ ReconciliationCustomerPayable }) => ({
        default: ReconciliationCustomerPayable,
      })
    )
  )
);
export const ReconciliationRoutes = [
 {
          path: `${APP_FILE_RECONCILIATION_AGENCY_BILL}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
              <ReconciliationAgencyBill />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_RECONCILIATION_DIRECT_BILL}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
              <ReconciliationDirectBill />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_RECONCILIATION_CUSTOMER_PAYABLE}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
              <ReconciliationCustomerPayable />
            </AuthorizedRoute>
          ),
        },
];
